import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import Newsletter from "../components/Newsletter";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const img = (p) => `${BACKEND}/api/static/img/${p}`;

// ==== CONTENU — 100% ancré dans le territoire (16 communes) ====
const AXES = [
    {
        id: "festivals",
        n: "01",
        kicker: "Rendez-vous annuels",
        title: "Les grands rituels",
        intro: "Trois rendez-vous ancrés dans le territoire, documentés, récurrents. Reprogrammés chaque année. Le Festival Côte Perdue viendra les rejoindre.",
        items: [
            {
                title: "Fête du Fromage — Neufchâtel-en-Bray",
                when: "Troisième week-end de septembre",
                note: "La capitale du plus vieux fromage AOP de Normandie fête son Neufchâtel — fabrication à la ferme, halle aux fromages, dégustations, défilé des producteurs.",
                image: "pl_auberge_bresle.jpg",
            },
            {
                title: "Brocante géante de Blangy-sur-Bresle",
                when: "Premier dimanche du mois · toute l'année",
                note: "180 exposants dès 5h30 sur la place et dans les rues. L'une des plus grandes brocantes-vides-greniers de Normandie-Picardie — chineurs, antiquaires, amateurs de flacons de parfumerie anciens. Entrée libre.",
                image: "xp_brocante_guided.jpg",
            },
            {
                title: "Journées Européennes du Patrimoine",
                when: "Troisième week-end de septembre",
                note: "Plus d'une vingtaine de sites ouvrent en même temps sur le territoire : Musée du Verre de Blangy, Château d'Eu, villas Belle Époque de Mers, collégiale d'Eu, Musée Mathon-Durand. Visites guidées gratuites — on voit ce qui reste fermé le reste de l'année.",
                image: "pl_table_chateau.jpg",
            },
            {
                title: "Festival Côte Perdue",
                when: "En préparation",
                note: "Un grand rendez-vous éditorial en cours de montage, dans un lieu du territoire. Long-table, voix acoustiques, conférences tardives, bal de clôture. Liste d'attente ouverte, date communiquée dès qu'elle est verrouillée.",
                image: "festival_dinner.jpg",
            },
        ],
    },
    {
        id: "concerts",
        n: "02",
        kicker: "Concerts",
        title: "Les scènes intimes",
        intro: "Des programmations musicales vivantes, dans des lieux du territoire. Vérifiez les dates auprès des organisateurs officiels.",
        items: [
            {
                title: "Rencontres Musicales Autour du Piano — Cayeux-sur-Mer",
                when: "Programmation annuelle",
                note: "Cycles de concerts autour du piano solo et de la musique de chambre, organisés sur la côte picarde. Programme et billetterie via les organisateurs.",
                image: "ev_concert_cliffs.jpg",
            },
            {
                title: "Soirées à la Table du Château d'Eu",
                when: "Printemps & été · quelques dates",
                note: "Le Théâtre du Château d'Eu (salle à l'italienne 1902, XIXᵉ ouvert au public) accueille quelques concerts et lectures par saison — musique ancienne, quatuors, piano. Programmation via la Ville d'Eu.",
                image: "xp_villa_privee.jpg",
            },
            {
                title: "Concerts en la Collégiale — Eu",
                when: "Été · quelques dates",
                note: "La collégiale Notre-Dame-et-Saint-Laurent, gothique primitif du XIIᵉ, accueille quelques concerts par an. Acoustique remarquable sous les voûtes. Programmation par la Ville d'Eu.",
                image: "pl_antiquaire.jpg",
            },
        ],
    },
    {
        id: "musees",
        n: "03",
        kicker: "Musées & lieux d'art",
        title: "L'œil qu'on ouvre",
        intro: "Les institutions permanentes du territoire — collections, démonstrations, jardins remarquables. Les expositions temporaires en cours sont listées dans la section précédente.",
        items: [
            {
                title: "Musée Louis-Philippe — Château d'Eu",
                when: "Mars à novembre · jeudi au dimanche",
                note: "Résidence d'été de Louis-Philippe (1830-1848), visite de la reine Victoria en 1843. Collections de porcelaines, argenterie, peintures, Galerie des Guise.",
                image: "v3/real_chateau_eu.jpg",
            },
            {
                title: "Musée du Verre — Blangy-sur-Bresle",
                when: "Avril à octobre · démonstrations quotidiennes",
                note: "30 000 flacons, histoire de la Vallée de la Bresle (75 % du flaconnage de parfumerie mondial depuis 1506), démonstrations de souffleurs en direct. Expositions temporaires.",
                image: "real/musee_verre_blangy.jpg",
            },
            {
                title: "Jardin Jungle Karlostachys — Saint-Martin-le-Gaillard",
                when: "Avril à octobre · classé Jardin Remarquable",
                note: "4 hectares d'exotisme absolu dans la vallée de l'Yères — bambous géants, fougères arborescentes, bananiers du Japon, lotus, gunneras. Une folie paysagère étonnante pour la Normandie.",
                image: "v3/goo_jardin_jungle_eu.jpg",
            },
            {
                title: "Musée Mathon-Durand — Neufchâtel-en-Bray",
                when: "Toute l'année",
                note: "Maison normande du XVIᵉ, labellisée Musée de France. Arts et traditions populaires du Pays de Bray, cave voûtée entièrement dédiée au Neufchâtel AOP.",
                image: "real/musee_mathon_durand.jpg",
            },
        ],
    },
    {
        id: "savoir-faire",
        n: "04",
        kicker: "Savoir-faire",
        title: "Les mains qui savent",
        intro: "Ce que le territoire fabrique encore, de ses mains, depuis longtemps. Documenté et visitable.",
        items: [
            {
                title: "Souffleurs de verre — Vallée de la Bresle",
                when: "Démonstrations au Musée du Verre, Blangy",
                note: "Depuis 1506, la Vallée de la Bresle souffle 75 % des flacons de parfumerie du monde — Guerlain, Chanel, Dior. Le Musée du Verre montre les techniques manuelles et mécaniques, avec démonstrations quotidiennes par deux souffleurs.",
                image: "xp_atelier_parfum.jpg",
            },
            {
                title: "Neufchâtel AOP — le plus vieux fromage d'Normandie",
                when: "Fermes ouvertes au public · Pays de Bray",
                note: "AOP depuis 1969, mentionné dès 1035 — bien avant le Camembert. Moulé en cœur, briquette, bonde ou double-bonde, affiné 10 jours en cave d'argile. Plusieurs fermes ouvrent pour dégustation et vente directe.",
                image: "pl_auberge_bresle.jpg",
            },
            {
                title: "Cabines peintes — Cayeux-sur-Mer",
                when: "Montées d'avril à octobre chaque année",
                note: "524 cabines nommées, alignées sur 2,5 km de planches de pin rouge — la plus longue promenade d'Europe. Tradition entamée fin XIXᵉ, entretenue à la charte chromatique municipale.",
                image: "xp_oyster_sunrise.jpg",
            },
            {
                title: "Villas Belle Époque — Mers-les-Bains",
                when: "Site Patrimonial Remarquable",
                note: "Près de 500 villas 1865-1905, façades polychromes Art déco et Art nouveau, restaurées maison par maison. Visites guidées par l'Office de Tourisme Destination Le Tréport – Mers.",
                image: "pl_villa_isabelle.jpg",
            },
        ],
    },
    {
        id: "legendes",
        n: "05",
        kicker: "Histoire vive",
        title: "Ce qu'on se raconte",
        intro: "Pas du folklore. Des faits historiques documentés, qui enracinent le territoire dans quelque chose de plus grand.",
        items: [
            {
                title: "Louis-Philippe reçoit Victoria — Château d'Eu",
                when: "Septembre 1843",
                note: "La reine Victoria, accompagnée d'Albert, effectue la première visite officielle d'un monarque britannique en France depuis le Camp du Drap d'Or de 1520. Louis-Philippe la reçoit au Château d'Eu, résidence d'été de la monarchie de Juillet. Les salles sont visitables.",
                image: "pl_table_chateau.jpg",
            },
            {
                title: "Oscar Wilde à Berneval-le-Grand",
                when: "Été 1897",
                note: "Sorti de la prison de Reading le 19 mai 1897, Wilde s'installe à Berneval-le-Grand sous le pseudonyme Sebastian Melmoth. Il y compose la première version de « La Ballade de la geôle de Reading », célèbre le jubilé de la reine Victoria avec les enfants du village, reçoit André Gide et Ernest Dowson.",
                image: "ct_berneval_grand.jpg",
            },
            {
                title: "L'abbaye cistercienne de Foucarmont",
                when: "Fondée en 1131",
                note: "Fondée par Hugues II d'Amiens, archevêque de Rouen, affiliée à l'ordre cistercien (filiation de Savigny), elle fut l'une des plus puissantes de Normandie. Détruite à la Révolution, il en reste des pierres sculptées intégrées à l'église paroissiale, le logis abbatial et une source captée — à découvrir à pied dans le bourg.",
                image: "dream/ct_foucarmont.jpg",
            },
            {
                title: "Briga — la cité gallo-romaine de la forêt d'Eu",
                when: "Ier – IIIe siècle",
                note: "Au cœur de la forêt d'Eu, à cheval sur Eu et Saint-Martin-le-Gaillard, le site de Bois-l'Abbé — la Briga antique — est la plus vaste agglomération gallo-romaine fouillée du nord de la France. Sanctuaire monumental, théâtre, thermes publics. Fouilles actives chaque été par le CRAHAM (CNRS), site accessible librement.",
                image: "real/foret_eu.jpg",
            },
            {
                title: "Les 500 villas Belle Époque de Mers",
                when: "1880 – 1914 · Site Patrimonial Remarquable",
                note: "Bâties pour la bourgeoisie d'affaires qui descendait alors en Pullman par la ligne Paris–Mers-les-Bains ouverte en 1872, les villas polychromes de Mers forment l'un des ensembles Belle Époque les plus denses d'Europe. Classées SPR depuis 1986, 500 façades préservées à découvrir à pied.",
                image: "real/villas_mers.jpg",
            },
        ],
    },
    {
        id: "underground",
        n: "06",
        kicker: "Côte Underground — bientôt",
        title: "Une scène à venir",
        intro: "Le territoire a toujours eu des scènes vivantes — musicales, littéraires, plastiques. Nous préparons une programmation éditoriale dédiée : soirées en petit comité, lectures, projections. Inscrivez-vous à la lettre pour être prévenu.",
        items: [],
        underground: true,
    },
];

export default function Scene() {
    const [liveExpos, setLiveExpos] = useState([]);
    const [exposLoading, setExposLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const r = await fetch(`${BACKEND}/api/events-live?limit=80`);
                if (!r.ok) throw new Error("events-live failed");
                const data = await r.json();
                const items = Array.isArray(data) ? data : (data.events || data.items || []);
                const expoRe = /(exposition|expo |\bvernissage\b)/i;
                const filtered = items
                    .filter((e) => expoRe.test((e.title || "") + " " + (e.description || "").slice(0, 240)))
                    .slice(0, 8);
                if (!cancelled) {
                    setLiveExpos(filtered);
                    setExposLoading(false);
                }
            } catch {
                if (!cancelled) setExposLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, []);

    return (
        <div data-testid="scene-page" className="bg-cp-ivoire">
            {/* HERO */}
            <section className="relative min-h-[70vh] md:min-h-[85vh] bg-cp-encre text-cp-ivoire overflow-hidden cp-grain">
                <img
                    src={img("hero_foret_eu_mist.jpg")}
                    alt=""
                    className="absolute inset-0 w-full h-full object-cover cp-kenburns-slow cp-photo-cinematic"
                />
                <div className="absolute inset-0 cp-hero-overlay" />

                <div className="relative z-10 min-h-[70vh] md:min-h-[85vh] max-w-[1600px] mx-auto px-5 sm:px-6 md:px-12 pt-32 md:pt-40 pb-20 flex flex-col justify-end">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                    >
                        <p className="cp-tiny text-cp-sable mb-8">Chapitre IX · Scène & Savoir-faire</p>
                        <h1 className="cp-serif text-[36px] sm:text-[52px] md:text-[72px] lg:text-[92px] xl:text-[112px] leading-[0.98] tracking-[-0.02em] max-w-5xl">
                            La côte <em className="cp-display-italic text-cp-sable">vit.</em><br />
                            Et elle <em className="cp-display-italic text-cp-sable">joue</em>.
                        </h1>
                        <p className="cp-serif italic text-base md:text-2xl font-light text-cp-ivoire/90 leading-[1.5] mt-8 max-w-3xl">
                            Six axes pour comprendre ce qui vit ici — festivals ancrés, concerts, musées et jardins, savoir-faire, histoire documentée, et la Côte Underground à venir.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* === LIVE EXPOSITIONS — pulled from OpenAgenda + Datatourisme === */}
            <section
                data-testid="scene-live-expositions"
                className="bg-cp-craie py-24 md:py-36 border-y border-cp-border"
            >
                <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-12">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 mb-16 md:mb-24">
                        <div className="md:col-span-5">
                            <div className="flex items-baseline gap-5 mb-6">
                                <span className="cp-serif italic text-5xl md:text-7xl text-cp-sable-deep">
                                    ✦
                                </span>
                                <span className="cp-tiny text-cp-terre">Expositions du moment</span>
                            </div>
                            <h2 className="cp-serif text-[44px] md:text-[80px] lg:text-[96px] leading-[0.9] tracking-[-0.03em]">
                                <em className="cp-display-italic">Ce qui s'expose</em><br />
                                <em className="cp-display-italic">en ce moment</em>
                            </h2>
                        </div>
                        <p className="md:col-span-6 md:col-start-7 cp-serif italic text-lg md:text-2xl font-light leading-[1.5] self-end text-cp-gris">
                            Mises à jour automatiquement depuis OpenAgenda et Datatourisme — agendas officiels des musées, châteaux et offices de tourisme du territoire.
                        </p>
                    </div>

                    {exposLoading ? (
                        <p className="cp-tiny text-cp-gris">Chargement des expositions en cours…</p>
                    ) : liveExpos.length === 0 ? (
                        <div className="bg-cp-ivoire/60 border border-cp-border p-8 md:p-10 max-w-3xl">
                            <p className="cp-serif italic text-lg text-cp-gris leading-snug">
                                Aucune exposition publiée pour l'instant dans les agendas officiels du territoire. Les institutions permanentes restent ouvertes — voir la section <em>Musées &amp; lieux d'art</em> ci-dessous.
                            </p>
                        </div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
                            {liveExpos.map((e, i) => (
                                <a
                                    key={e.url || e.title || i}
                                    href={e.url || "#"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid={`scene-live-expo-${i}`}
                                    className="group block"
                                >
                                    <div className="cp-image-zoom aspect-[4/3] bg-cp-encre overflow-hidden mb-6">
                                        {e.image ? (
                                            <img
                                                src={e.image}
                                                alt=""
                                                loading="lazy"
                                                className="w-full h-full object-cover cp-photo-cinematic"
                                            />
                                        ) : (
                                            <div className="w-full h-full flex items-center justify-center bg-cp-sable/30">
                                                <span className="cp-script text-5xl text-cp-sable-deep/60">expo</span>
                                            </div>
                                        )}
                                    </div>
                                    <p className="cp-tiny text-cp-terre mb-3">
                                        {e.city || e.location || "Côte Perdue"}
                                        {e.date_start ? ` · ${String(e.date_start).slice(0, 10)}` : ""}
                                    </p>
                                    <h3 className="cp-serif text-3xl md:text-4xl leading-[1.05] tracking-[-0.01em] mb-4 group-hover:text-cp-foret transition">
                                        {e.title}
                                    </h3>
                                    {e.description && (
                                        <p className="cp-serif italic text-lg text-cp-gris leading-snug max-w-xl">
                                            {String(e.description).slice(0, 220)}{String(e.description).length > 220 ? "…" : ""}
                                        </p>
                                    )}
                                </a>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            {/* AXES */}
            {AXES.map((ax, idx) => (
                <section
                    id={ax.id}
                    key={ax.id}
                    data-testid={`scene-axis-${ax.id}`}
                    className={`py-24 md:py-36 ${
                        ax.underground
                            ? "bg-cp-terre text-cp-ivoire cp-grain"
                            : idx % 2 === 0
                                ? "bg-cp-ivoire text-cp-encre"
                                : "bg-cp-craie text-cp-encre"
                    }`}
                >
                    <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-12">
                        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-14 mb-16 md:mb-24">
                            <div className="md:col-span-5">
                                <div className="flex items-baseline gap-5 mb-6">
                                    <span className={`cp-serif italic text-5xl md:text-7xl ${ax.underground ? "text-cp-ivoire/50" : "text-cp-sable-deep"}`}>{ax.n}</span>
                                    <span className={`cp-tiny ${ax.underground ? "text-cp-ivoire/80" : "text-cp-terre"}`}>{ax.kicker}</span>
                                </div>
                                <h2 className={`cp-serif text-[44px] md:text-[80px] lg:text-[96px] leading-[0.9] tracking-[-0.03em] ${ax.underground ? "text-cp-ivoire" : ""}`}>
                                    <em className="cp-display-italic">{ax.title}</em>
                                </h2>
                            </div>
                            <p className={`md:col-span-6 md:col-start-7 cp-serif italic text-lg md:text-2xl font-light leading-[1.5] self-end ${ax.underground ? "text-cp-ivoire/85" : "text-cp-gris"}`}>
                                {ax.intro}
                            </p>
                        </div>

                        {ax.underground ? (
                            <div className="max-w-3xl mx-auto text-center pt-10">
                                <p className="cp-serif italic text-4xl md:text-6xl text-cp-ivoire/95 mb-12">
                                    — Lancement fin 2026 —
                                </p>
                                <div className="bg-cp-ivoire/10 border border-cp-ivoire/20 p-8 md:p-12 backdrop-blur-sm">
                                    <p className="cp-tiny text-cp-ivoire/80 mb-6">Carnet noir · Inscription</p>
                                    <Newsletter variant="dark" source="underground-waitlist" />
                                    <p className="cp-tiny text-cp-ivoire/60 mt-6">Vous serez prévenu en priorité. Rien d'autre. Promis.</p>
                                </div>
                            </div>
                        ) : (
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
                                {ax.items.map((it, i) => (
                                    <article
                                        key={i}
                                        data-testid={`scene-item-${ax.id}-${i}`}
                                        className="group"
                                    >
                                        <div className="cp-image-zoom aspect-[4/3] bg-cp-encre overflow-hidden mb-6">
                                            <img
                                                src={img(it.image)}
                                                alt=""
                                                loading="lazy"
                                                className="w-full h-full object-cover cp-photo-cinematic"
                                            />
                                        </div>
                                        <p className="cp-tiny text-cp-terre mb-3">{it.when}</p>
                                        <h3 className="cp-serif text-3xl md:text-4xl leading-[1.05] tracking-[-0.01em] mb-4">
                                            {it.title}
                                        </h3>
                                        <p className="cp-serif italic text-lg text-cp-gris leading-snug max-w-xl">
                                            {it.note}
                                        </p>
                                    </article>
                                ))}
                            </div>
                        )}
                    </div>
                </section>
            ))}

            {/* Newsletter */}
            <section className="bg-cp-ivoire py-20 md:py-28 border-t border-cp-border">
                <div className="max-w-[1000px] mx-auto px-6 md:px-12">
                    <p className="cp-tiny text-cp-foret mb-6">La lettre de Côte Perdue</p>
                    <h3 className="cp-serif text-5xl md:text-7xl leading-[0.92] text-cp-encre mb-4">
                        Une <em className="cp-display-italic">lettre</em>. Par mois.
                    </h3>
                    <p className="cp-script text-2xl text-cp-sable-deep mb-10">Rien d'autre.</p>
                    <div className="max-w-xl">
                        <Newsletter variant="light" source="scene" />
                    </div>
                </div>
            </section>
        </div>
    );
}
